<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('规则名称')">
              <a-input :placeholder="$t('请输名称进行查询')" v-model="queryParam.warnName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('发送频次')">
               <a-select
                      v-model="queryParam.sendFrequency"
                      style="width: 100%"
                      :placeholder="$t('请选择发送频次')"
                    >
                      <a-select-option v-for="(item,key) in messageFrequencyObj" :value="key" :key="key">
                        {{ $t(item) }}
                      </a-select-option>
                    </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="enable" slot-scope="text, record">
          <label :class="record.enable === 0?'unenable':'enable'">{{record.enable === 0?$t('不启用'):$t('启用')}}</label>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <alarm-config-modal ref="modalForm" @ok="modalFormOk"></alarm-config-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import alarmConfigModal from './modules/alarmConfigModal'
  import {isUndefined} from '@/utils/validate'
  import {messageFrequencyObj,messageSendWayObj} from '@/utils/constants/commonConstant'

  export default {
    name: 'AlarmConfigList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
        alarmConfigModal
    },
    data () {
      return {
        description: this.$t('告警配置页面'),
        messageSendWayObj,
        messageFrequencyObj,
        url: {
          list: "/jeecg-charge/meter/meterMessageConfig/list",
          delete: "/jeecg-charge/meter/meterMessageConfig/delete",
          deleteBatch: "/jeecg-charge/meter/meterMessageConfig/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterMessageConfig/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterMessageConfig/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('规则名称'),
            align:"center",
            dataIndex: 'warnName'
          },
          {
            title: this.$t('发送频次'),
            align:"center",
            dataIndex: "sendFrequency",
            customRender: (t,r,index) => {
                if(!isUndefined(messageFrequencyObj[t])) {
                    return this.$t(messageFrequencyObj[t])
                }
              return this.$t('未知');
            }
          },
          {
            title: this.$t('发送模板'),
            align:"center",
            dataIndex: "templateName"
          },
          {
            title: this.$t('是否启用'),
            align:"center",
            dataIndex: "enable",
            scopedSlots: { customRender: 'enable' }
          },
           {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
    }
  }
</script>
<style scoped>
    .enable{
    background: #0ebad5;
    border:  1px solid #0ebad5;
    padding: 5px;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: bolid;
    color: white;
  }
  .unenable{
    background: gray;
    border:  1px solid gray;
    padding: 5px;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: bolid;
    color: white; 
  }
</style>